import React from 'react';
import { Icon, Label, Image } from 'react-frontier';
import { Employment } from '../SiteClasses';
import { Link } from 'react-router-dom';
import moment from 'moment';

interface EmploymentCardProps {
	employment: Employment;
	onClick?: () => void;
}

export interface EmploymentStatus {
	color: 'red' | 'green' | 'blue' | 'yellow';
	text: string;
}

export function getEmploymentStatus(employment: Employment): EmploymentStatus{
	var isActive = moment().isBetween(moment.unix(employment.date_start), moment.unix(employment.date_end));
	var isFinished = moment().isAfter(moment.unix(employment.date_end));

	if(employment.deleted){
		return {
			color: 'yellow',
			text: 'Deshabilitado',
		};
	}
	if(isActive){
		return {
			color: 'green',
			text: 'Activo',
		};
	}
	if(isFinished){
		return {
			color: 'red',
			text: 'Finalizado',
		};
	}
	return {
		color: 'blue',
		text: 'Próximamente',
	};
}

var EmploymentCard = (props: EmploymentCardProps)=>{
	var e = props.employment;
	var employmentStatus = getEmploymentStatus(e);

	return (
		<Link to={`/employments/${e.employment_id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
			<div className="ar employment-card" onClick={props.onClick}>
				<div className="icon-container">
					<Image src={'/placeholder.png'} fallback='/placeholder.png' height={100} style={{ borderRadius: 4 }}/>
				</div>
				<div className="content">
					<div className="name">{e.employment_name}</div>
					<div className="details">
						<div className="item">
							<Icon name='calendar-alt'/>
							<div className="text">
								{moment.unix(e.date_start).format('DD/MM/YYYY')} - {moment.unix(e.date_end).format('DD/MM/YYYY')}
							</div>
						</div>
						<div className="item">
							<Icon name='clock' />
							<div className="text">{moment.unix(e.date_end).diff(moment.unix(e.date_start), 'days') + 1} {moment.unix(e.date_end).diff(moment.unix(e.date_start), 'days') + 1 === 1 ? 'día' : 'días'}</div>
						</div>
					<div className="item">
						<Icon name='map-marker-alt' />
						<div className="text">{e.city}, {e.country}</div>
					</div>
					</div>
				</div>
				<div className="status-column">
					<Label
						className="status-label"
						color={employmentStatus.color}
						style={{ width: 100 }}
					>
						{employmentStatus.text}
					</Label>
					<div className="employee-count">
						<Icon name='users' />
						<span>{e.employee_count}</span>
					</div>
				</div>
			</div>
		</Link>
	);
}

export default EmploymentCard;
